import { getEmploymentData } from '~/data/employee';
import { useSWR } from '~/hooks/useSWR';

export const useEmploymentData = (props: { employeeId: number }) => {
  const { employeeId } = props;
  const { data, isLoading, error } = useSWR(
    ['employmentData', employeeId],
    () => getEmploymentData(employeeId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
